/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Faq_Desktop_AInputs */

const en_mk_faq_desktop_a = /** @type {(inputs: Mk_Faq_Desktop_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desktop is optional. Run coding in the cloud from your browser or connect a supported computer through the CLI. The current Desktop package is for Linux x64 and requires Node.js 22+ and a separately installed official agent. Windows and macOS Desktop packages are not yet available as supported releases.`)
};

const id_mk_faq_desktop_a = /** @type {(inputs: Mk_Faq_Desktop_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desktop bersifat opsional. Kamu bisa menjalankan coding di cloud melalui browser, atau menghubungkan komputer yang didukung melalui CLI. Paket Desktop saat ini tersedia untuk Linux x64 dan memerlukan Node.js 22+ serta agent resmi yang dipasang terpisah. Desktop Windows dan macOS belum tersedia sebagai rilis siap pakai.`)
};

/**
* | output |
* | --- |
* | "Desktop is optional. Run coding in the cloud from your browser or connect a supported computer through the CLI. The current Desktop package is for Linux x64 ..." |
*
* @param {Mk_Faq_Desktop_AInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_faq_desktop_a = /** @type {((inputs?: Mk_Faq_Desktop_AInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Faq_Desktop_AInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_faq_desktop_a(inputs)
	return en_mk_faq_desktop_a(inputs)
});